import {
    convertPrice,
    price,
    formatPrice,
    priceFormat,
    imageUrl,
    dateFormat,
    dateShortFormat,
    dateTimeFormat,
    hoursFromDate,
    durationFormat,
    stripHtml,
} from '~/utils/filters'
import {srcHost} from '~src/utils/host-adapter'

export default defineNuxtPlugin(() => {
    const filters = {
        convertPrice,
        price,
        formatPrice,
        priceFormat,
        imageUrl,
        dateFormat,
        dateShortFormat,
        dateTimeFormat,
        hoursFromDate,
        durationFormat,
        stripHtml,
        srcHost,
    }
    return {provide: {filters}}
})
